/**
 * @fileoverview Utilitaires transverses du design system GNPC.
 *
 * Ce module regroupe les helpers appelés partout dans `packages/ui` et dans
 * les apps consommatrices. Toute fonction ajoutée ici doit rester pure,
 * sans dépendance à React ni au DOM, pour être utilisable côté serveur
 * (générateurs de PDF, tests unitaires) autant que côté navigateur.
 */

import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Concatène des classes CSS conditionnelles et déduplique intelligemment
 * les conflits Tailwind (ex : `p-2` + `p-4` → `p-4`).
 *
 * Convention shadcn/ui : c'est LE helper à utiliser sur chaque `className`
 * combiné, plutôt qu'une concaténation manuelle. Le résultat reste stable
 * pour React (mêmes classes → même string), donc pas de re-render inutile.
 *
 * @param inputs - N'importe quel argument accepté par `clsx` : string,
 *   objet `{ 'is-active': boolean }`, tableau, `undefined`, `null`, `false`.
 * @returns La chaîne de classes finale, prête à passer à `className`.
 *
 * @example
 * ```tsx
 * <button className={cn('rounded-md px-3', isPrimary && 'bg-primary', className)} />
 * ```
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}